import { ConfigContext, GroupSectionTitle, SMPContainer, Tournament, useSizeContext } from '@velinsi/smp-widgets-ui';
import { useContext, useState } from 'react';
import { GenericSize, INLINE_ODDS_BREAKPOINT, MAX_MOBILE_WIDTH, MAX_WIDGET_WIDTH } from '../../../../../../packages/constants/generic';
import useResizeObserver from '../../../../../../packages/hooks/useResizeObserver';
import {
  INormalizedTennisMatch,
  INormalizedTournamentData,
  ISubscriberInfoFn,
  ITournamentProps,
  SportType,
} from '../../../../../../packages/types';
import EventInfo, { IEventInfoProps } from '../EventInfo/EventInfo';
import useOverlapOdds from '../../../../../../packages/hooks/useOverlapOdds';

export interface IEventRowWithCompetitionProps {
  sport: SportType;
  showOdds?: boolean;
  isMobile?: boolean;
  matches: INormalizedTennisMatch[];
  competition?: INormalizedTournamentData;
  showRoundName?: boolean;
  showCompetition?: boolean;
  handleClick: ISubscriberInfoFn;
  handleCompetitionClick: ITournamentProps['handleTournamentClick'];
  handleEventClick: IEventInfoProps['handleEventClick'];
  allowInlineOdds?: boolean;
}

function EventRowWithCompetition({
  sport,
  matches,
  showOdds,
  isMobile,
  competition,
  handleClick,
  handleCompetitionClick,
  handleEventClick,
  showRoundName = false,
  showCompetition = true,
  allowInlineOdds = true,
}: IEventRowWithCompetitionProps): JSX.Element {
  const [size, setSize] = useState<GenericSize>();
  const { setIsMobile } = useSizeContext();
  const [width, setWidth] = useState(MAX_WIDGET_WIDTH);
  const { dataBettingLogoOverlap } = useContext(ConfigContext);
  const { areBettingOddsOverlapVisible } = useOverlapOdds({ dataBettingLogoOverlap });

  const measuredRef = useResizeObserver((fieldElement) => {
    setSize(allowInlineOdds && fieldElement.offsetWidth >= INLINE_ODDS_BREAKPOINT ? GenericSize.DEFAULT : GenericSize.SMALL);
    setWidth(fieldElement.offsetWidth);
    setIsMobile(fieldElement.offsetWidth < MAX_MOBILE_WIDTH);
  });

  return (
    <>
      {showCompetition && (
        <Tournament sport={sport} tournament={competition} handleTournamentClick={handleCompetitionClick} isMainImageRound={true} />
      )}
      <SMPContainer ref={measuredRef} variant='paddinglessContainer' style={{ opacity: Number(!!size) }}>
        {matches?.map((match) => (
          <div key={match?.id}>
            {showRoundName && <GroupSectionTitle title={match?.round?.name} />}
            <EventInfo
              handleEventClick={handleEventClick}
              isMobile={isMobile}
              key={match.id}
              match={match}
              showOdds={showOdds}
              participants={match?.participants}
              handleClick={handleClick}
              showCurrentServer
              size={size}
              width={width}
              wrapperLink
              areBettingOddsOverlapVisible={areBettingOddsOverlapVisible}
            />
          </div>
        ))}
      </SMPContainer>
    </>
  );
}

export default EventRowWithCompetition;
